import {Head} from '@aboutyou/head-elements';
import {useQueryParams} from '@aboutyou/router';
import React from 'react';

/**
 * This component adds a live shopping purchase tracking script to the page head.
 *
 * There's an ability to exclude it from the page if necessary
 * by setting the ?disablePurchaseTracking=1 query parameter.
 */
export const LiveShoppingPurchaseTrackingScript: React.FC = () => {
  const queryParams = useQueryParams();
  const disablePurchaseTracking = queryParams.get('disablePurchaseTracking');

  if (disablePurchaseTracking === '1') {
    return null;
  }

  return (
    <Head>
      <script
        async
        id="live-shopping-purchase-tracking"
        type="text/javascript"
        src={`/live-shopping-purchase-tracking.js`}
      />
    </Head>
  );
};

export function withPurchaseTracking<T>(
  InnerComponent: React.ComponentType<React.PropsWithChildren<T>>,
) {
  const WrappedComponent: React.FC<React.PropsWithChildren<T>> = props => {
    return (
      <>
        <LiveShoppingPurchaseTrackingScript />
        <InnerComponent {...props} />
      </>
    );
  };
  return WrappedComponent;
}
